import { render, staticRenderFns } from "./VGlobalError.vue?vue&type=template&id=0af23ca5"
import script from "./VGlobalError.vue?vue&type=script&lang=js"
export * from "./VGlobalError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports